import type { SessionScenario } from "../../models";
import { useManifestStore } from "../../state/manifestStore";

export function ScenarioPanel({ scenario, userId }: { scenario: SessionScenario; userId: string }) {
  const userName = useManifestStore((s) => s.manifest?.users.find((u) => u.id === userId)?.name);
  return (
    <aside className="scenario-panel">
      <dl>
        <div>
          <dt>User</dt>
          <dd>{userName}</dd>
        </div>
        <div>
          <dt>Persona</dt>
          <dd>{scenario.user_persona}</dd>
        </div>
        <div>
          <dt>Task</dt>
          <dd>{scenario.business_task}</dd>
        </div>
        {scenario.rationale ? (
          <div>
            <dt>Why this illustrates the pattern</dt>
            <dd>{scenario.rationale}</dd>
          </div>
        ) : null}
      </dl>
    </aside>
  );
}
